import { ITab } from '@/shared/Tabs/tabs.types.ts'
import { TNotificationCenterTab } from './notificationCenter.types.ts'
import { ISystemEvent } from '@/pages/SystemEvents/systemEvents.types.ts'

const cardTabs: ITab<TNotificationCenterTab>[] = [
  { title: 'Уведомления', id: 'userNotifications' },
  { title: 'Все события', id: 'allSystemEvents' },
]

const initSelectedEventType: ISystemEvent['type'][] = [
  'ALARM_SITUATION_INCIDENT',
  'SYSTEM_LOG',
  'LP_ERROR',
  'MOVED_TO_MAINTENANCE',
]

const notificationCenterConstants = { cardTabs, initSelectedEventType }
export default notificationCenterConstants
